import { render, staticRenderFns } from "./gc-sales-contract-product-details.vue?vue&type=template&id=66f28b18"
import script from "./gc-sales-contract-product-details.vue?vue&type=script&lang=js"
export * from "./gc-sales-contract-product-details.vue?vue&type=script&lang=js"
import style0 from "./gc-sales-contract-product-details.vue?vue&type=style&index=0&id=66f28b18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports